import React from 'react';
import { motion } from 'framer-motion';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

function CareerTimeline() {
  const progression = setup.careerProgression || [];

  return (
    <MotionSection id="career-timeline">
      <SectionHeader
        eyebrow="Growth"
        title="Career Timeline"
        subtitle="How my engineering scope expanded from PHP SaaS to enterprise ERP, cloud, and AI."
      />

      {/* Mobile: vertical */}
      <div className="relative md:hidden">
        <div className="absolute left-4 top-2 bottom-2 w-px bg-line-strong" aria-hidden />
        <div className="space-y-8">
          {progression.map((entry, index) => (
            <motion.div
              key={entry.year}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="relative pl-12"
            >
              <div className="absolute left-2.5 top-1.5 w-3 h-3 rounded-full bg-accent border-2 border-canvas" />
              <p className="text-sm font-bold text-accent tabular-nums mb-2">{entry.year}</p>
              <div className="flex flex-wrap gap-2">
                {entry.milestones.map((milestone) => (
                  <span
                    key={milestone}
                    className="text-sm font-medium text-ink px-2.5 py-1 rounded-md bg-canvas-muted border border-line"
                  >
                    {milestone}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Desktop: horizontal */}
      <div className="hidden md:block relative">
        <div className="absolute top-6 left-0 right-0 h-px bg-line-strong" aria-hidden />
        <div className="grid grid-cols-5 gap-4">
          {progression.map((entry, index) => (
            <motion.div
              key={entry.year}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08 }}
              className="relative pt-10 text-center"
            >
              <div className="absolute top-[18px] left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-accent border-2 border-canvas z-10" />
              <p className="text-sm font-bold text-accent tabular-nums mb-3">{entry.year}</p>
              <div className="flex flex-col gap-1.5 items-center">
                {entry.milestones.map((milestone) => (
                  <span
                    key={milestone}
                    className="text-xs font-medium text-ink px-2 py-1 rounded-md bg-canvas-muted border border-line w-full"
                  >
                    {milestone}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </MotionSection>
  );
}

export default CareerTimeline;
